import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui';

import "swiper/dist/css/swiper.min.css"
import "./assets/css/public.css"
import "./assets/css/style.css"
// import 'wowjs/css/libs/animate.css'
// import 'animate.css'
import 'video.js/dist/video-js.css'

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
    ak: 'dGe0TeskRxCpRREAPESKWaGc9uKXXiMy'
})

Vue.use(ElementUI);

Vue.config.productionTip = false


// 引入dayjs
import dayjs from "dayjs"
Vue.prototype.dayjs = dayjs

import axios from 'axios'
Vue.prototype.$http = axios

//  交通建设 / 集团 
Vue.prototype.webId = 'b6e7222f-5893-4b05-915d-99266af99abb'  // 交通建设
Vue.prototype.webIdGroup = 'BEE8AB69-65E3-4161-ACF7-0E09E4028BB8'  //集团

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')